// accountSelectionApi.ts

import { apiPaths, baseApi } from '@services';
import { Account, BackendAccount, GetAccountsArgs } from '../types';
import { transformAccount } from './mapper';
import { APIFinalArgs, QueryResponse } from '@common/types/queryState';
import { transformQueryResponse } from '@common/utils/';

const extendedApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAccounts: builder.query<
            QueryResponse<Account>,
            APIFinalArgs<GetAccountsArgs>
        >({
            query: ({ userId }) => ({
                url: apiPaths.data.getAccounts(userId),
            }),
            transformResponse: (response: BackendAccount[], meta, arg) =>
                transformQueryResponse(response, meta, arg, transformAccount),
        }),
    }),
});

export const { useGetAccountsQuery } = extendedApi;

export default extendedApi.endpoints;
